import React from 'react';




import CustomSelect from 'components/other/CustomSelect';
import { Label1 } from 'components/main/AddBag/AddBag.styled';
import CustomSelect1 from 'components/other/CustomSelect1';




const BagShopUpdate = ({ point, shopsData, setPoint }) => {

  console.log('point :>> ', point);

  return (
    // <Label htmlFor="pickupPoint">
    //   <Select id="pickupPoint" defaultValue={inShop} onChange={handleSelectChange}>
    //     {shopsData.map((shop) => (
    //       <option key={shop.id} value={shop.id}>
    //         Точка видачі №{shop.id} ({shop.address})
    //       </option>
    //     ))}
    //   </Select>

    // </Label>

    <Label1 htmlFor="pickupPoint" style={{ width: "100%" }}>

      <CustomSelect1
        id="pickupPoint"
        name="pickupPoint"
        width={"100%"}
        options={[...shopsData.map((shop) => `${shop.name} (${shop.address})`)]}
        selectedValue={point}
        onChange={setPoint}
      />

    </Label1>

  );
};

export default BagShopUpdate;